
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as versionSuH3fAnQn6Woc48fOjx5S9SkDPdMKUSXSaKBxw1asAMMeta } from "/usr/src/app/pages/version.vue?macro=true";
import { default as trendingMFFwVBtAV5dCSfkv_xyxeFkn5ZqFiqRgPno87LTcGxsMeta } from "/usr/src/app/pages/trending.vue?macro=true";
import { default as following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta } from "/usr/src/app/pages/following.vue?macro=true";
import { default as indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta } from "/usr/src/app/pages/index/index.vue?macro=true";
import { default as indexKL1wCeozGMBCT22nspO12AtQxPyyqLOjuDnNk_MCwfYMeta } from "/usr/src/app/pages/[company]/index.vue?macro=true";
import { default as _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta } from "/usr/src/app/pages/public-product/[id].vue?macro=true";
import { default as indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta } from "/usr/src/app/pages/[company]/[store]/index.vue?macro=true";
import { default as _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta } from "/usr/src/app/pages/source-product/[sourceUrl].vue?macro=true";
import { default as indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta } from "/usr/src/app/pages/[company]/[store]/[category]/index.vue?macro=true";
import { default as _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta } from "/usr/src/app/pages/[company]/[store]/[category]/[product].vue?macro=true";
import { default as _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta } from "/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue?macro=true";
export default [
  {
    name: "version___en",
    path: "/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___es",
    path: "/es/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___fr",
    path: "/fr/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___nl",
    path: "/nl/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___pt",
    path: "/pt/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___pt-BR",
    path: "/pt-BR/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___uk",
    path: "/uk/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "version___ru",
    path: "/ru/version",
    component: () => import("/usr/src/app/pages/version.vue")
  },
  {
    name: "trending___en",
    path: "/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___es",
    path: "/es/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___fr",
    path: "/fr/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___nl",
    path: "/nl/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___pt",
    path: "/pt/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___pt-BR",
    path: "/pt-BR/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___uk",
    path: "/uk/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "trending___ru",
    path: "/ru/trending",
    component: () => import("/usr/src/app/pages/trending.vue")
  },
  {
    name: "following___en",
    path: "/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___es",
    path: "/es/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___fr",
    path: "/fr/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___nl",
    path: "/nl/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___pt",
    path: "/pt/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___pt-BR",
    path: "/pt-BR/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___uk",
    path: "/uk/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "following___ru",
    path: "/ru/following",
    meta: following59yaOxeHVju7QjPFaCGJxifNbtk6qH1BsKHvmwW0Vf4Meta || {},
    component: () => import("/usr/src/app/pages/following.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___pt-BR",
    path: "/pt-BR",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexNlfWl7hBWsJL3wAafIv0tKNewcV_dhQ_VnmbPVrTZsQMeta || {},
    component: () => import("/usr/src/app/pages/index/index.vue")
  },
  {
    name: "company___en",
    path: "/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___es",
    path: "/es/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___fr",
    path: "/fr/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___nl",
    path: "/nl/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___pt",
    path: "/pt/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___pt-BR",
    path: "/pt-BR/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___uk",
    path: "/uk/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "company___ru",
    path: "/ru/:company()",
    component: () => import("/usr/src/app/pages/[company]/index.vue")
  },
  {
    name: "public-product-id___en",
    path: "/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___es",
    path: "/es/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___fr",
    path: "/fr/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___nl",
    path: "/nl/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___pt",
    path: "/pt/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___pt-BR",
    path: "/pt-BR/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___uk",
    path: "/uk/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "public-product-id___ru",
    path: "/ru/public-product/:id()",
    meta: _91id_93ikrmt0RFZuvUqFXjliHxbGjUhQFduj47de8Y6doeyAYMeta || {},
    component: () => import("/usr/src/app/pages/public-product/[id].vue")
  },
  {
    name: "company-store___en",
    path: "/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___es",
    path: "/es/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___fr",
    path: "/fr/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___nl",
    path: "/nl/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___pt",
    path: "/pt/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___pt-BR",
    path: "/pt-BR/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___uk",
    path: "/uk/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "company-store___ru",
    path: "/ru/:company()/:store()",
    meta: indexAfmktN_45mnQuzV8UpgqY6_LsAWiYK_453UilxjNrtR85noMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/index.vue")
  },
  {
    name: "source-product-sourceUrl___en",
    path: "/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___es",
    path: "/es/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___fr",
    path: "/fr/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___nl",
    path: "/nl/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___pt",
    path: "/pt/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___pt-BR",
    path: "/pt-BR/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___uk",
    path: "/uk/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "source-product-sourceUrl___ru",
    path: "/ru/source-product/:sourceUrl()",
    meta: _91sourceUrl_93JeOtxpS8EvJzlAhCe8ZkwHntiaOOnyOERs8E3vzP94EMeta || {},
    component: () => import("/usr/src/app/pages/source-product/[sourceUrl].vue")
  },
  {
    name: "company-store-category___en",
    path: "/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___es",
    path: "/es/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___fr",
    path: "/fr/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___nl",
    path: "/nl/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___pt",
    path: "/pt/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___pt-BR",
    path: "/pt-BR/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___uk",
    path: "/uk/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category___ru",
    path: "/ru/:company()/:store()/:category()",
    meta: indexS2fUZ2d_45J0yNe5dLLPT6q1hBWQJaXakGJolLq6YbI08Meta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/index.vue")
  },
  {
    name: "company-store-category-product___en",
    path: "/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___es",
    path: "/es/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___fr",
    path: "/fr/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___nl",
    path: "/nl/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___pt",
    path: "/pt/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___pt-BR",
    path: "/pt-BR/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___uk",
    path: "/uk/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product___ru",
    path: "/ru/:company()/:store()/:category()/:product()",
    meta: _91product_93m231BGbybO81mFPLSfSOOumt2JZ9L7FGK3CP0CKDPakMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product].vue")
  },
  {
    name: "company-store-category-product-embedded___en",
    path: "/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___es",
    path: "/es/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___fr",
    path: "/fr/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___nl",
    path: "/nl/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___pt",
    path: "/pt/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___pt-BR",
    path: "/pt-BR/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___uk",
    path: "/uk/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  },
  {
    name: "company-store-category-product-embedded___ru",
    path: "/ru/:company()/:store()/:category()/:product()-embedded",
    meta: _91product_93_45embeddedKuSdlZ94z17ByEVMExTxQdO2oq2Q0hT9okn7xhuZcxMMeta || {},
    component: () => import("/usr/src/app/pages/[company]/[store]/[category]/[product]-embedded.vue")
  }
]